import React from 'react';

import { s, brand, gray, white, radius } from '../theme';

/**
 * Switch control, ported from `Program Entry Updates/src/components/ui/Toggle.tsx`.
 *
 * Used for the sidebar's "show required only" filter and for the boolean fields that
 * read as on/off rather than as a choice — online program, disable overnight.
 *
 * `description` is optional sub-label text rendered beneath the switch. The prototype puts
 * it on a checkbox (`ui/Inputs.tsx` `Checkbox`), but Disable Overnight is the only field
 * that needs it and it already reads as a switch here — so the text hangs off this instead
 * of introducing a second control for one field.
 */
const Toggle = ({ id, label, description, checked, onChange, labelStyle }) => (
    <div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <label
                htmlFor={id}
                style={{ fontSize: '12.5px', fontWeight: 600, marginBottom: 0, ...labelStyle }}
            >
                {label}
            </label>
            <button
                type="button"
                id={id}
                role="switch"
                aria-checked={checked}
                aria-label={label}
                onClick={() => onChange(!checked)}
                style={{
                    position: 'relative',
                    display: 'inline-flex',
                    alignItems: 'center',
                    height: '20px',
                    width: '36px',
                    flexShrink: 0,
                    padding: 0,
                    border: 'none',
                    borderRadius: radius.pill,
                    backgroundColor: checked ? brand[600] : gray[300],
                    cursor: 'pointer',
                    transition: 'background-color 0.15s',
                }}
            >
                <span
                    style={{
                        display: 'inline-block',
                        height: '16px',
                        width: '16px',
                        borderRadius: radius.pill,
                        backgroundColor: white,
                        boxShadow: '0 1px 2px rgba(0,0,0,0.2)',
                        transform: checked ? 'translateX(18px)' : 'translateX(2px)',
                        transition: 'transform 0.15s',
                    }}
                />
            </button>
        </div>

        {description ? <p style={s.hint}>{description}</p> : ''}
    </div>
);

export default Toggle;
